import React, {Component} from 'react'
import {Button, Col, Form, Input, Row, Select,} from 'antd';
import authorizePage from "../../components/authorize/authorizePage";
import UserSubEditableTable from "./user-sub-table";

class UserSublist extends Component {

    state = {
        loading: false,
        visible: false,
    }

    updateVisible =(visible)=>{
        this.setState({
            visible:visible
        })
    }
    searchList=()=>{
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    params:values
                })
            }
        });
    }



    componentDidMount() {
        this.searchList()
    }

    render() {

        const form = this.props.form
        const { getFieldDecorator } = form;
        return (
            <div>
                <div className='box-shadow margin-bootom'>
                    <br/>
                    <Form labelCol={{
                        lg: {span: 7},
                        md: {span: 9},
                    }}
                          wrapperCol={{
                              lg: {span: 14},
                              md: {span: 12},
                          }}
                    >
                        <Row>
                            <Col span={6}>
                                <Form.Item label="昵称">
                                    {getFieldDecorator('nickName', {
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="地区">
                                    {getFieldDecorator('address', {
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="姓名">
                                    {getFieldDecorator('userName', {
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={6}>
                                <Form.Item label="等级">
                                    {getFieldDecorator('level', {
                                        initialValue:'',
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Select.Option value="">全部</Select.Option>
                                        <Select.Option value="1">一般</Select.Option>
                                        <Select.Option value="2">严重</Select.Option>
                                    </Select>)}
                                </Form.Item>
                            </Col>
                            <Col span={6}>
                                <Form.Item label="状态">
                                    {getFieldDecorator('status', {
                                        initialValue:'',
                                        rules: [
                                            {
                                                required: false,
                                            },
                                        ],
                                    })(<Select getPopupContainer={triggerNode => triggerNode.parentNode}>
                                        <Select.Option value="">全部</Select.Option>
                                        <Select.Option value="subscribe">正常</Select.Option>
                                        <Select.Option value="unsubscribe">已退订</Select.Option>
                                    </Select>)}
                                </Form.Item>
                            </Col>

                            <Col span={6} style={{float: 'right', marginBottom: '20px'}}>
                                <Button type='primary' htmlType='submit'
                                        style={{float: 'right', marginRight: '13%'}} onClick={(e)=>{
                                    e.preventDefault();
                                    this.searchList()
                                }}>查询</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className='box-shadow'>
                    <UserSubEditableTable params={this.state.params}/>
                </div>
            </div>

        )
    }
}

const UserSublistForm = authorizePage()(Form.create()(UserSublist))
export default UserSublistForm